import React from 'react';

// Global table configuration
export const TABLE_CONFIG = {
  // Pagination settings
  pagination: {
    defaultPage: 1,
    defaultPerPage: 15,
    perPageOptions: [10, 15, 25, 50, 100]
  },

  // Table settings
  table: {
    defaultSortColumn: 'id',
    defaultSortDirection: 'ascending' as const,
    staleTime: 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    refetchOnWindowFocus: false
  },

  // UI settings
  ui: {
    loadingSkeletonCount: 10,
    emptyStateMessage: 'No data found',
    errorStateMessage: 'Failed to load data'
  }
} as const;

// Helper function to create pagination params
export const createPaginationParams = (
  page: number = TABLE_CONFIG.pagination.defaultPage,
  perPage: number = TABLE_CONFIG.pagination.defaultPerPage
) => ({
  page,
  per_page: perPage
});

// Helper function to create table query options
export const createTableQueryOptions = <T = any,>(options: {
  queryKey: unknown[];
  queryFn: () => Promise<T>;
  enabled?: boolean;
}) => ({
  queryKey: options.queryKey,
  queryFn: options.queryFn,
  enabled: options.enabled,
  staleTime: TABLE_CONFIG.table.staleTime,
  gcTime: TABLE_CONFIG.table.gcTime,
  retry: TABLE_CONFIG.table.retry,
  refetchOnWindowFocus: TABLE_CONFIG.table.refetchOnWindowFocus
});

// Helper function to create sort descriptor
export const createSortDescriptor = (
  column: string = TABLE_CONFIG.table.defaultSortColumn,
  direction: 'ascending' | 'descending' = TABLE_CONFIG.table.defaultSortDirection
) => ({
  column,
  direction
});

// Helper function to create loading skeleton
export const createLoadingSkeleton = (count: number = TABLE_CONFIG.ui.loadingSkeletonCount): React.ReactNode[] =>
  Array.from({ length: count }, (_, i) => (
    <div key={i} className="flex w-full items-center gap-3">
      <div className="h-6 w-1/3 animate-pulse rounded bg-gray-200" />
      <div className="h-6 w-1/3 animate-pulse rounded bg-gray-200" />
      <div className="h-6 w-1/6 animate-pulse rounded bg-gray-200" />
      <div className="h-6 w-1/6 animate-pulse rounded bg-gray-200" />
    </div>
  ));
